import React, { useState } from 'react';
import styled from 'styled-components';
import WeeklyAchievementChart from 'components/presenters/chart/WeeklyAchievementChart';
import MonthlyAchievementChart from 'components/presenters/chart/MonthlyAchievementChart';




export default function MyPageAchievementChart({chartWeekendData,chartMonthData}) {
    const [graphswitch,setGraphswitch] = useState(false);

    function clickswitch(){
        setGraphswitch(!graphswitch);
    }        

    return(
    <MypageAchieveInner>
        <MaintitBar>
            <Maintit>주간 / 월간 달성률</Maintit>
            <div>
                <Switchinput type="checkbox" checked={graphswitch} readOnly  id="weekedSW" onClick={clickswitch}></Switchinput>
                <Switchlabel htmlFor="weekedSW">
                    <Switchtext>주간</Switchtext>
                    <Switchtext>월간</Switchtext>
                </Switchlabel>
            </div>
        </MaintitBar>
        {
            graphswitch == true? 
            <MonthlyAchievementChart chartMonthData={chartMonthData}/>
            :
            <WeeklyAchievementChart chartWeekendData={chartWeekendData}/>
        }
    </MypageAchieveInner>

    )
}




const MypageAchieveInner = styled.div` 
    padding :  calc(100vw*(31/375)) calc(100vw*(17/375)) 0 calc(100vw*(17/375));
    overflow: hidden;
`

const MaintitBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom : calc(100vw*(24/375));
`
const Maintit = styled.p`
    font-size: calc(100vw*(16/375));
    font-weight: bold;
    
` 

const Switchinput = styled.input`
    display:none;

    // &:checked + label {background-color: #ffcf19;}
    &:checked + label::before {transform: translate(calc(100vw*(34/375)),-50%);  content: '월간';}
`
const Switchlabel = styled.label`
    position: relative;
    padding: 0 calc(100vw*(9/375));
    display: flex;
    justify-content: space-between;
    width: calc(100vw*(78/375));
    height: calc(100vw*(30/375));
    border-radius: calc(100vw*(20/375));
    background-color:  #ffe89b;
    font-size: calc(100vw*(12/375));
    font-weight: 500;
    letter-spacing: -0.29px;
    color: #4e4e4e;

    &::before {
        content: '주간';
        display:block;
        width:  calc(100vw*(40/375));
        height:  calc(100vw*(26/375));
        box-shadow: 0  calc(100vw*(1/375))  calc(100vw*(6/375)) 0 rgba(0, 0, 0, 0.16);
        background-color: #ffffff;
        position: absolute;
        left: calc(100vw*(2/375));
        top: 50%;
        transform: translateY(-50%);    
        transition : all .5s ease;
        border-radius: calc(100vw*(13/375));
        color: #4e4e4e;
        line-height: calc(100vw*(26/375));
        text-align: center;

    }
`
const Switchtext = styled.span`
font-size: calc(100vw*(12/375));
font-weight: 500;
line-height: calc(100vw*(30/375));
letter-spacing: -0.29px;
color: #989898;
`